import React, {useEffect, useRef, useState, } from 'react';

import {
    ExpandMoreSharp,
    CheckCircle,
} from '@mui/icons-material'

import "./LanguageSwitcher.css";
import { 
    Stack, 
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
} from '@mui/material';
import useLocalStorage from '../../../hooks/useLocalStorage';
import CONSTANT from '../../../Constant/Constant';


/**
 * @description - Takes the place of the Weglot language picker, incorporates the same functionality.
 * 
 * @param {boolean} - openDialog when true, language dialog is opened.
 * @param {()=> void} - onCloseDialog will close dalog when invoked.
 * @param {boolean} - isDialog will display component as dialog when true, othwerwise it mimics 
 * Weglot API language picker.
 * 
 */
export default function LanguageSwitcher({isDialog=false, openDialog, onCloseDialog}) {


    /* store ISO language codes as keys and have their locales as values along with image data */
    const [languageMapper, setLanguageMapper] = useState({});
    const [searchLang, setSearchLang] = useState("")
    const [filteredLanguageMapper, setFilteredLanguageMapper] = useState({})
    const [langLocaleChange, setLangLocaleChange] = useLocalStorage('wglang_api')


    const [showDropdown, setShowDropdown] = useState(false);


    /* Store the ISO Language code of the current language example: "en" for English */
    const [selectedDialogLanguage, setSelectedDialogLanguage] = useState(
       langLocaleChange
    );

    const clickRef = useRef(null);

    /* Initialize dropdown values with respective ISO-639-1 codes and their locales  */
    useEffect(()=> {
        const localLanguageNames = {
            "en":{
                locale: "English"
            }
        };
        window?.Weglot?.options?.languages?.forEach(({language_to, custom_code})=> {
            const locale = custom_code ? custom_code : language_to
            const localName = window.Weglot.getLanguageName(locale);
            localLanguageNames[locale] = {
                locale: `${localName}` ,
            };
        });
        setLanguageMapper(localLanguageNames);
            
        if(localLanguageNames && Object.keys(localLanguageNames).includes(langLocaleChange) === false){
            setLangLocaleChange('en');
            setSelectedDialogLanguage('en');
            onSwitchLanguage('en');
        }
        else{
            onSwitchLanguage(langLocaleChange);
            setLangLocaleChange(langLocaleChange);
            setSelectedDialogLanguage(langLocaleChange);
        }
       
        
        /* detect a click that is not from the language switcher */
        document.addEventListener('mousedown',handleClickAway);

        return ()=> {
            document.removeEventListener('mousedown',handleClickAway);
        }

    },[]);


    function handleClickAway(e) {
        if(clickRef.current && !clickRef.current.contains(e.target)){
            setShowDropdown(false);
            setSearchLang('');
            setFilteredLanguageMapper({});
        }
    }

    
    function onSwitchLanguage(ISO_lang_code) {
        window.Weglot.switchTo(CONSTANT.LANGLOCALE_EN.includes(ISO_lang_code) ? 'en' : ISO_lang_code);
        setSelectedDialogLanguage(ISO_lang_code);
        setLangLocaleChange(ISO_lang_code)
        setShowDropdown(false);
        setSearchLang('');
        setFilteredLanguageMapper({});
    }

    function onSwitchDialogLanguage(){
        window.Weglot.switchTo(selectedDialogLanguage);
        onCloseDialog();
    }


    //remove any selects that did not follow with a confirm.
    function onCancel() {
        setSelectedDialogLanguage(langLocaleChange);
        onCloseDialog();
    }

    function handleSearch(value){
        setSearchLang(value)
        setFilteredLanguageMapper(
            Object.keys(languageMapper).filter(d => languageMapper[d]?.locale?.toLocaleLowerCase()?.includes(value?.toLowerCase()))
        )
    }

    return (
        <>
            {
                isDialog === false?(
                <div 
                    ref={clickRef} 
                    className="custom-wg-dropdown-container"
                > 
                    <div 
                        className="ls-displayed-lang"
                        onClick={()=> setShowDropdown(!showDropdown)}
                    >
                        {
                            Object.keys(languageMapper).length !== 0 &&(
                            <Stack 
                                direction={'row'} 
                                justifyContent={'center'}
                                gap={1}
                                alignItems={'center'}
                                whiteSpace='nowrap'
                            >
                                {window.Weglot.getLanguageName(langLocaleChange || window.Weglot.getCurrentLang())+ " "}
                                <ExpandMoreSharp
                                    style={{transform:showDropdown?'rotate(180deg)':'', transition:'50ms linear all'}}
                                />
                            </Stack>
                            )
                        }
                    </div>
                    <div className={`${showDropdown?'ls-slider ls-toggled-slider':'ls-slider'}`}>
                        {   showDropdown && (
                            <div className="ls-header">
                                {/* <Typography 
                                    textAlign={'center'} 
                                    fontSize={'0.8rem'} 
                                    color={'gray'}
                                >Select a language</Typography> */}
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    autoComplete='off'
                                    type="text"
                                    placeholder='Search a language'
                                    inputProps={{style: {fontSize: '0.8rem', paddingLeft:'8px', paddingRight: '8px'}}} 
                                    name="searchLangLocale"
                                    onChange={e => handleSearch(e.target.value)}
                                />
                            </div>
                            )
                        }
                        <div className={"ls-expandable"}>
                                {
                                    showDropdown === true &&
                                        searchLang ?
                                        filteredLanguageMapper.length ? filteredLanguageMapper.map((ISO_lang_code) => {
                                            return (
                                                <Stack
                                                    key={ISO_lang_code}
                                                    direction={'row'}
                                                    alignItems={'center'}
                                                    onClick={() => onSwitchLanguage(ISO_lang_code)}
                                                    className='ls-language-item'
                                                    gap={1}
                                                >
                                                    {languageMapper[ISO_lang_code].locale}
                                                </Stack>
                                            );
                                        }) : <Typography 
                                                textAlign={'center'} 
                                                fontSize={'0.8rem'} 
                                                color={'gray'}
                                                padding={2}
                                            >
                                                Not Found
                                            </Typography> 
                                        :
                                        Object.keys(languageMapper).map((ISO_lang_code) => {
                                            return (
                                                // Stack is used becuase you can add a flag icon if there are any available.
                                                //Weglot JS API does not provide such assets so just the text will have to suffice.
                                                <Stack
                                                    key={ISO_lang_code}
                                                    direction={'row'}
                                                    alignItems={'center'}
                                                    onClick={() => onSwitchLanguage(ISO_lang_code)}
                                                    className='ls-language-item'
                                                    gap={1}
                                                >
                                                    {languageMapper[ISO_lang_code].locale}
                                                </Stack>
                                            );
                                        })
                                }
                        </div>
                    </div>
                </div>
                ):(
                    <Dialog
                        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
                        maxWidth="xs"
                        open={openDialog}
                        onClose={onCancel}
                    >
                        <DialogTitle className='_wg-dynamic-text'>
                            Choose Language 
                            ({
                                window.Weglot.getLanguageName(langLocaleChange)
                            })
                        </DialogTitle>
                        <DialogContent dividers>
                            {
                                
                                Object.keys(languageMapper).map((ISO_lang_code)=> {
                                    if(langLocaleChange === ISO_lang_code) return;

                                    return (
                                        <Box
                                            sx={{
                                                padding: '10px', 
                                                "&:hover":{background:'rgb(245,245,245)'},
                                                cursor:'pointer'
                                            }}
                                            key={ISO_lang_code}
                                            onClick={(()=> setSelectedDialogLanguage(ISO_lang_code))}
                                            display='flex'
                                            justifyContent={'space-between'}

                                        >

                                            <Typography 
                                                fontSize={'1rem'}
                                                variant='body1'
                                                margin={0}
                                                padding={0}
                                            >
                                                {languageMapper[ISO_lang_code].locale}
                                                
                                            </Typography>
                                            {
                                                selectedDialogLanguage === ISO_lang_code && (
                                                    <CheckCircle color='primary'/>
                                                )
                                            }
                                            
                                        </Box>
                                    )
                                })
                            }
                        </DialogContent>
                        <DialogActions>
                            <Button 
                                sx={{textTransform:'none'}}
                                onClick={onCancel}
                                color='error'
                                className="_wg-dynamic-text"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={onSwitchDialogLanguage}
                                sx={{textTransform: 'none'}}
                                disabled={selectedDialogLanguage === langLocaleChange}
                                className="_wg-dynamic-text"
                            >
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>
                )
            }
        </>
    );
}